import { useLayoutEffect, useState } from "react";
import { isChatContainerAtBottom } from "utils/chat";

export const useScrollMovement = (
  containerRef?: React.RefObject<HTMLElement | null>
) => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const handleScroll = () => {
    if (containerRef) {
      const container = containerRef.current;
      if (!container) return;

      const isScrollable = container.scrollHeight > container.clientHeight + 40;
      const threshold = 5;
      const isAtBottom = isChatContainerAtBottom(
        container.scrollTop,
        threshold
      );
      setShowScrollButton(isScrollable && !isAtBottom);
    } else {
      const isScrollable = window.innerHeight + 40 < document.body.scrollHeight;
      const threshold = 5;
      const isAtBottom =
        window.innerHeight + window.scrollY >=
        document.body.scrollHeight - threshold;

      setShowScrollButton(isScrollable && !isAtBottom);
    }
  };

  const handleScrollDown = () => {
    if (containerRef) {
      const container = containerRef.current;
      if (!container) return;
      container.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }
  };

  useLayoutEffect(() => {
    if (containerRef) {
      const container = containerRef.current;
      if (!container) return;
      handleScroll();
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    } else {
      handleScroll();
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  useLayoutEffect(() => {
    const target = containerRef ? containerRef.current : document.body;
    if (!target) return;
    const observer = new MutationObserver(handleScroll);
    observer.observe(target, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return { showScrollButton, handleScrollDown };
};
